import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Avatar,
  Typography,
  Stack,
  Rating,
  useTheme,
  alpha
} from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';

const InstructorCard = ({ teacher, sx = {} }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      onClick={() => navigate(`/instructor/${teacher.id}`)}
      sx={{
        minWidth: { xs: 150, sm: 170 },
        width: { xs: 150, sm: 170 },
        flexShrink: 0,
        scrollSnapAlign: 'start',
        p: 2.5,
        textAlign: 'center',
        cursor: 'pointer',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
          borderColor: 'primary.main',
        },
        ...sx
      }}
    >
      <Avatar
        src={teacher.image || teacher.profileImage}
        sx={{
          width: 64,
          height: 64,
          mx: 'auto',
          mb: 1.5,
          border: '2px solid',
          borderColor: alpha(theme.palette.primary.main, 0.2),
        }}
      >
        {teacher.name?.charAt(0)}
      </Avatar>
      <Typography variant="subtitle2" fontWeight={700} noWrap>
        {teacher.name}
      </Typography>
      {teacher.rank && (
        <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block', mt: 0.25 }}>
          {teacher.rank}
        </Typography>
      )}
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} sx={{ mt: 1.5 }}>
        <Rating value={teacher.avgRating || 0} precision={0.1} size="small" readOnly sx={{ fontSize: '0.85rem' }} />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} sx={{ mt: 0.5 }}>
        <SchoolIcon sx={{ fontSize: 13, color: 'text.disabled' }} />
        <Typography variant="caption" color="text.secondary">
          {teacher.courseCount || teacher.totalCourses || 0} {(teacher.courseCount === 1 || teacher.totalCourses === 1) ? 'course' : 'courses'}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default InstructorCard;
